import React, { createContext, useContext } from 'react';
import { useTracking } from './useTracking';

const TrackingContext = createContext(null);

export function TrackingProvider({ children }) {
  const tracking = useTracking();
  return (
    <TrackingContext.Provider value={tracking}>
      {children}
    </TrackingContext.Provider>
  );
}

export function useTrack() {
  const ctx = useContext(TrackingContext);
  if (!ctx) {
    // Fallback no-op if outside provider
    return { trackEvent: () => {} };
  }
  return ctx;
}


